// #region Contrôle d’une requête en archive
/**
 * Util to check if url requested is authorized to be prefixed with "Archive""
 * This prefix will be deleted in next version API.
 * To delete at this moment.
 */
export class ArchiveUtil {
  /**
   * Appel autorisé en archive : même verbe ET même adresse (segments « {} » = n'importe quelle valeur).
   * Correctif : l'adresse était comparée à toutes les entrées sans tenir compte du verbe (un GET d'avancement prenait
   * le préfixe d'un POST de même forme).
   */
  static isAuthorized(method: string, url: string): boolean {
    const segments = decouper(url);
    return ARCHIVE_AUTHORIZED.some(
      (a, i) => a.methods.includes(method as HTTP_METHOD) && correspond(segments, URL_AUTHORIZED_SPLITTED[i]),
    );
  }
}

function decouper(url: string): string[] {
  return url
    .toLocaleLowerCase()
    .split('/')
    .filter((a) => a.length > 0);
}

function correspond(segments: string[], modele: string[]): boolean {
  return segments.length === modele.length && segments.every((s, i) => s === modele[i] || modele[i] === '{}');
}
const enum HTTP_METHOD {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
}
// #endregion

// #region Adresses autorisées en archive
const ARCHIVE_AUTHORIZED = [
  {
    url: '/Balance/Generale/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Generale/CycleComptable/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Client/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Fournisseur/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Client/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Fournisseur/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Generale/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Generale/Date/CycleComptable/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Revision/{}/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte/Search/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Compte/{}',
    methods: [HTTP_METHOD.PUT],
  },
  {
    url: '/Centralisateur',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Centralisateur/Desequilibre',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Ecriture',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/Search/{}/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/Rapprochement',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Ecriture/Saisie',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Journal',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Journal',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Journal/Sourced',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Journal/Dossier/Search/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire/Ecriture/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Intercalaire/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/TableCloture',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Export/Fec',
    methods: [HTTP_METHOD.POST],
  },
  // Outils du dossier actifs en archive (bureau AddPrefixeUrl) : recalcul des soldes, exports FEC / Logaia / spécifique.
  {
    url: '/Controle/RecalculSoldes',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Controle/RecalculSoldes/Avancement/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Export/Fec/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Export/Logaia/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Export/CodeBasic/{}/{}',
    methods: [HTTP_METHOD.POST],
  },
  // Plan comptable : appels que le bureau préfixe en archive (CompteService.AddPrefixeUrl) : recherche, cases Périodicité
  // et Détail clôture, rattachement en lot et son avancement.
  {
    url: '/Compte/Search',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Compte/{}/Periodicite/{}',
    methods: [HTTP_METHOD.PUT],
  },
  {
    url: '/Compte/{}/DetailCloture/{}',
    methods: [HTTP_METHOD.PUT],
  },
  {
    url: '/Compte/RattachementEnLot',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Compte/RattachementEnLot/Avancement/{}',
    methods: [HTTP_METHOD.GET],
  },
  // Consultation des journaux du collaborateur : le bureau préfixe ces trois appels en archive (AddPrefixeUrl).
  {
    url: '/Journal/CodeJournalFromEcriture',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Journal/SearchJournauxEcrituresByCodeAndPeriode',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Journal/ExportPdf',
    methods: [HTTP_METHOD.POST],
  },
  // Ventilation analytique d'une écriture en lecture (bureau AnalyticService.SearchCouples, AddPrefixeUrl).
  {
    url: '/Analytic/Comptes/SearchCouples',
    methods: [HTTP_METHOD.POST],
  },
];

const URL_AUTHORIZED_SPLITTED = ARCHIVE_AUTHORIZED.map((a) => decouper(a.url));
// #endregion
